
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState, useEffect,useRef} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

const CustomDialog = ({title,subtitle,maxWidth = "md",open,setOpen,  children, onClose=null }) => {
     useEffect(() => {
       
     }, [open]);

    const handleClose = () => {
        if(onClose){
            onClose()
        }
        setOpen(false);
    };

    return (<Dialog
        open={open}
        onClose={handleClose}
        maxWidth={maxWidth}
        fullWidth={true}
     >
       {/* <form onSubmit={handleSubmit} role="form">  */}
     <DialogTitle><h4>{title}</h4></DialogTitle>
     <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
   <DialogContent>
     <DialogContentText>
        <h5><b>{subtitle}</b></h5>
     </DialogContentText>
     <div className='row mb-6'>
        <div className='col-lg-12'>
        {children}
                {/* {typebutton == 'button' ? (
                    <>
                        {children}
                    </>
                ) : (
                <>
                <form onSubmit={onSubmit} role="form"> 
                    {children}
                </form>
                </>
              )} */}
  
        </div>
     </div>
     
   </DialogContent>
   <DialogActions>
     {/* <button className='btn' onClick={handleClose} type='button'>CANCEL</button> */}
     {/* {typebutton == "submit" && (
         <button className='btn btn-primary' type='submit'>{textbutton}</button>
     )}

     {typebutton == "button" && (
         <button className='btn btn-primary' type='button' onClick={onsubmit}>{textbutton}</button>
     )}

     {typebutton == "none" && (
        <></>
     )}
     */}
   </DialogActions>
   {/* </form> */}
 </Dialog>)
}

export default CustomDialog
